import axios from 'axios';

// Determine API URL: use localhost in development, otherwise use environment or fallback empty
const host = window.location.hostname;
const isLocal = host === 'localhost' || host === '127.0.0.1';
const API_URL = isLocal
  ? 'https://nivaas.app'
  : (process.env.REACT_APP_API_URL || '');
console.log('Utils API: using baseURL:', API_URL);
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 